import * as commonEnums from '../../../enums';
import { ChargeSessionCodeType } from '../../../enums';

const { FieldType } = commonEnums;
export const GripIcon: CMxCommonApp.IconField = {
  key: 'gripper',
  path: [],
  readonly: false,
  width: 'minmax(min-content, 10%)',
  value: null,
  svgIconName: 'BiomeGripperSVG20',
  svgIconSize: '20',
  svgIconClass: 'gripper',
  classNames: ['units-column', 'code-gripper', 'gripper'],
  fieldType: FieldType.Icon
};

const unitIsNotOriginal = {
  path: ['original'],
  isNot: null // true to disable for original codes, false to disable for nonOriginal, null to allow both
};

const assessmentIsAdditionalUnits = {
  path: ['codeAssessment', 'assessment'],
  is: 'ADDITIONAL UNIT OF CODED CPT'
};

export const UnitCount: CMxCommonApp.TextInputField = {
  key: 'units',
  path: ['units'],
  readonly: false,
  width: 'minmax(min-content, 10%)',
  classNames: [
    ['code-units-input'],
    ['units-column', 'code-units-populateable', 'prevent-click'],
    ['case-units-numeral']
  ],
  displayName: null,
  fieldType: FieldType.TextInput,
  validateInputString: '^\\d+$',
  inputEnableRules: [unitIsNotOriginal, assessmentIsAdditionalUnits]
};

const codeClassNames = ['codes-column'];
export const CPTCode: CMxCommonApp.CodeField = {
  codeType: ChargeSessionCodeType.PROCEDURE,
  key: 'code',
  path: ['code'],
  readonly: false,
  width: 'minmax(min-content, 20%)',
  fieldType: FieldType.Code,
  onCodeDelete: value => {},
  classNames: codeClassNames
};

export const ICDCode: CMxCommonApp.CodeField = {
  codeType: ChargeSessionCodeType.DIAGNOSIS,
  key: 'code',
  path: ['code'],
  readonly: false,
  width: 'minmax(min-content, 20%)',
  fieldType: FieldType.Code,
  onCodeDelete: value => {},
  classNames: codeClassNames
};

export const ModifierCode: CMxCommonApp.CodeField = {
  codeType: ChargeSessionCodeType.MODIFIER,
  key: 'code',
  path: ['code'],
  readonly: false,
  width: 'minmax(min-content, 20%)',
  fieldType: FieldType.Code,
  onCodeDelete: value => {},
  classNames: codeClassNames
};

export const defaultAssessmentOptionsTreePath = [['original']];
export const modifierAssessmentOptionsTreePath = [['code'], ['original']];

export const AssesmentSelect: CMxCommonApp.SelectListField = {
  key: 'assessment',
  path: ['codeAssessment', 'assessment'],
  readonly: false,
  width: '1fr',
  defaultOptions: [],
  optionsPath: 'assessmentOptions',
  placeholder: 'Select Assessment',
  onSelect: value => {},
  fieldType: FieldType.SelectList,
  rerenderFields: ['id', 'code', 'sequenceNumber'],
  optionsTreePath: defaultAssessmentOptionsTreePath
};

const roleOptionsTreePath = [['codeAssessment', 'assessment']];
export const modifierRoleOptionsTreePath = [
  ['code'],
  ['codeAssessment', 'assessment']
];

export const RoleSelect: CMxCommonApp.SelectListField = {
  key: 'role',
  path: ['codeAssessment', 'role'],
  readonly: false,
  width: '1fr',
  defaultOptions: [],
  optionsPath: 'roleOptions',
  placeholder: 'Select Role',
  onSelect: value => {},
  fieldType: FieldType.SelectList,
  optionsTreePath: roleOptionsTreePath,
  rerenderFields: ['id', 'code', 'sequenceNumber']
};

export const Icon: CMxCommonApp.IconField = {
  key: 'check',
  path: ['check'],
  readonly: false,
  width: 'minmax(50px, 10%)',
  value: null,
  svgIconName: 'BiomeCheckSVG20',
  svgIconSize: '20',
  svgIconClass: 'check',
  classNames: [],
  fieldType: FieldType.Icon,
  optionsTree: {}
};

export const BaseCQACodeAssessmentIcon: CMxCommonApp.IconField = {
  key: 'baseCQACodeAssessmentIcon',
  path: [''],
  readonly: false,
  width: '0fr',
  value: null,
  svgIconName: '',
  svgIconSize: '16',
  svgIconClass: '',
  classNames: ['assessment-icon-container'],
  fieldType: FieldType.Icon,
  optionsTree: {}
};
